// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Container test Match con el snapshot 1`] = `<div class="wrap-container"></div>`;
